module.exports = __webpack_public_path__ + "img/162.b5dd36cf.jpg";